import { componentClassName } from '@/styles/Footer';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type FooterDescriptionProps = ComponentProps<'div'>;

export const FooterDescriptionComponent: Component<FooterDescriptionProps> = ({
  variant,
  size,
  colors,
  children,
  ...props
}) => {
  const className = componentClassName('description', { variant, size, colors });

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
